<p-confirmDialog key="confirmDialog"></p-confirmDialog>
<div class="nav static">
    <p-toolbar>
        <div #logo class="p-toolbar-group-start">
            <img class="logo" src="./assets/images/{{ theme() }}.png" height="28px" />
            <div class="sidebar-toggle" [ngClass]="{ open: sidebarOpen }" (click)="toggleSidebar()" pRipple>
                <div class="side-bar-toggle">
                    <i class="pi pi-bars"></i>
                </div>
            </div>
        </div>
        <div #user class="p-toolbar-group-end">
            <button pButton pRipple type="button" icon="pi pi-info-circle"
                class="p-button-rounded p-button-text p-button-lg p-disabled"></button>
            <button pButton pRipple type="button" icon="pi pi-cog"
                class="p-button-rounded p-button-text p-button-lg p-disabled"></button>
            <div (click)="toggleSelect.toggle($event)" class="user-toolbar"
                [ngClass]="{ active: toggleSelect.overlayVisible }">
                <p class="text-action">{{ userName | async }}</p>
                <i
                    class="pi pi-{{ toggleSelect.overlayVisible ? 'angle-up' : 'angle-down' }} mr-2 ml-2 text-xl text-action"></i>
                <p-avatar icon="pi pi-user" styleClass="p-avatar" size="large" shape="circle"></p-avatar>
            </div>
            <div #accountDropTarget></div>
        </div>
    </p-toolbar>
</div>
<div class="container">
    <div #sideBarContainer>
        <p-drawer [(visible)]="sidebarOpen" [modal]="false" [closeOnEscape]="false" [appendTo]="sideBarContainer"
            [showCloseIcon]="false" styleClass="mainMenu" position="left">
            <ng-template #header>
                <div class="product-menu">
                    <p-panelMenu [model]="applicationRouteItems()" [multiple]="true">
                        <ng-template #item let-item>
                            @if (!item.items) {
                            <!-- Single item without children (like Home) -->
                            <a [routerLink]="item.route" routerLinkActive="p-menuitem-link-active"
                                [routerLinkActiveOptions]="{exact: true}"
                                class="p-menuitem-link p-panelmenu-header-link"
                                (isActiveChange)="this.onRouterLinkActive($event)">
                                <span [pTooltip]="item.state?.iconTooltipText" tooltipPosition="right"><span
                                        [class]="item.icon + ' p-menuitem-icon'"></span></span>
                                <span [pTooltip]="item.state?.itemToolTipText" tooltipPosition="right" class="p-menuitem-text">{{ item.label }}</span>
                            </a>
                            } @else {
                            @if (item.url) {
                            <!-- External URL item -->
                            <a [href]="item.url" routerLinkActive="p-menuitem-link-active"
                                class="p-panelmenu-header-link">
                                <span [class]="item.iconClass"><span
                                        [class]="item.icon + ' p-menuitem-icon'"></span></span>
                                <span class="p-menuitem-text">*{{ item.label }}</span>
                            </a>
                            } @else {
                            <!-- Parent item with children (like Guideline Planning) -->
                            <!-- Use a custom handler that prevents the default PanelMenu behavior -->
                            <a class="p-panelmenu-header-link"
                                [ngClass]="{'p-menuitem-link-active': isSectionActive(item)}"
                                (click)="$event.preventDefault(); $event.stopPropagation(); toggleMenuExpansion($event, item);">
                                <span [class]="item.iconClass"><span
                                        [class]="item.icon + ' p-menuitem-icon'"></span></span>
                                <span class="p-menuitem-text">{{ item.label }}</span>
                                @if (item.items) {
                                <i class="pi text-primary ml-auto p-icon p-submenu-icon"
                                    [ngClass]="{ 'pi-chevron-down': item.expanded, 'pi-chevron-right': !item.expanded }"></i>
                                }
                            </a>
                            }
                            }
                        </ng-template>
                    </p-panelMenu>
                </div>
            </ng-template>
        </p-drawer>
    </div>
    <section class="child-container">
        <unified-ui-navigation-tabs></unified-ui-navigation-tabs>
    </section>
</div>
<!-- CHECK: [showCloseIcon]="false" popover -->
<p-popover #toggleSelect [appendTo]="accountDropTarget" for="toggleSelect" [showTransitionOptions]="'100ms'"
    [hideTransitionOptions]="'0ms'" [dismissable]="true">
    <!-- TODO: remove p-disabled when implementing Support and feedback -->
    <div class="select-item mb-1 p-disabled">
        <i class="pi pi-question-circle mr-2"></i>
        Support & Feedback
    </div>
    <div class="select-item mt-1">
        <i class="pi pi-desktop mr-2"></i>Dark Mode<span class="push"></span>
        <p-toggleswitch class="ml-2" [(ngModel)]="darkChecked" (ngModelChange)="onThemeChange()"></p-toggleswitch>
    </div>
    <div class="select-item mb-1" (click)="logout()">
        <i class="pi pi-sign-out icon-logout mr-2"></i>
        Sign Out
    </div>
</p-popover>

<p-toast key="platform-message" position="bottom-right" styleClass="platform-toast"></p-toast>
@if (builderComponentToRender()) {
<ng-container [ngComponentOutlet]="builderComponentToRender() ?? null"></ng-container>
}

<!-- Debug component for lazy loading verification -->
<unified-ui-lazy-loading-debug></unified-ui-lazy-loading-debug>